import { graphql } from '@/graphql-setup'

export const USER_EXPORT_QUERY = graphql(`
  query UserExport($id: ID!) {
    userExport(id: $id) {
      id
      progress
      exception
      name
      file
    }
  }
`)

export const ALL_USER_EXPORTS_QUERY = graphql(`
  query AllUserExports($orderBy: String, $first: Int, $after: String) {
    allUserExports(orderBy: $orderBy, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          createdAt
          name
          file
          module
          progress
          exception
          downloadedAt
        }
      }
    }
  }
`)
